export const formatMoney = (value?: number | null) => {
  if (value === undefined || value === null) return ''
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

export const formatPercentage = (value?: number | null) => {
  if (value === undefined || value === null) return ''
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value / 100)
}

export const formatDate = (date: Date | string, options: Intl.DateTimeFormatOptions = {}) => {
  if (!date) return 'N/A'
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...options,
  }).format(new Date(date))
}
